var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListAlternative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navicon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "coolicon",
    d: "M7.33333 2.66602H14V3.99935H7.33333V2.66602ZM7.33333 5.33268H11.3333V6.66602H7.33333V5.33268ZM7.33333 9.33268H14V10.666H7.33333V9.33268ZM7.33333 11.9993H11.3333V13.3327H7.33333V11.9993ZM2 2.66602H6V6.66602H2V2.66602ZM3.33333 3.99935V5.33268H4.66667V3.99935H3.33333ZM2 9.33268H6V13.3327H2V9.33268ZM3.33333 10.666V11.9993H4.66667V10.666H3.33333Z",
    fill: "#082234"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAlternative);
export default __webpack_public_path__ + "static/media/list-alternative.e103fcada76e750c8decb1dc9c5d2883.svg";
export { ForwardRef as ReactComponent };